import {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TagManager from 'react-gtm-module';
import {AddressUpdateThankYou} from './pages/CustomerUpdate/AddressUpdateThankYou';
import {Faq} from './pages/Faq/Faq.jsx';
import {PrivacyPolicy} from './pages/PrivacyPolicy/PrivacyPolicy.jsx';
import {TermsOfUse} from './pages/TermsOfUse/TermsOfUse.jsx';
import {Landing} from './pages/Landing/Landing.jsx';
import {SignUp} from './pages/SignUp/SignUp.jsx';
import {SignUpThankYou} from './pages/SignUpThankYou/SignUpThankYou.jsx';
import {SignUpThankYouOrdering} from './pages/SignUpThankYouOrdering/SignUpThankYouOrdering.jsx';
import {SignUpThankYouAlreadyDone} from './pages/SignUpThankYouAlreadyDone/SignUpThankYouAlreadyDone.jsx';
import {CustomerUpdate} from './pages/CustomerUpdate/CustomerUpdate.jsx';
import {History} from './pages/History/History.jsx';
import logo from './logo.svg';
import './App.css';

function App() {
  useEffect(() => {
    if ((process.env.REACT_APP_ENV == 'prod') || (process.env.REACT_APP_ENV == 'dev')) {
      TagManager.initialize({
        gtmId: "GTM-5HMZLCX"
      });
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/thankyou" element={<SignUpThankYou />} />
        <Route path="/thankyouorder" element={<SignUpThankYouOrdering />} />
        <Route path="/thankyoualreadydone" element={<SignUpThankYouAlreadyDone />} />
        <Route path="/thankyouaddressupdate" element={<AddressUpdateThankYou />} />
        <Route path="/customerupdate/:code" element={<CustomerUpdate />} />
        <Route path="/history/:code" element={<History/>} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/termsofuse" element={<TermsOfUse />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
